import { useRef, useState } from 'react';

/**
 * 마우스 드래그로 스크롤 가능한 기능을 제공하는 훅
 * 데스크톱 환경에서만 동작하며, 모바일에서는 네이티브 터치 스크롤 사용
 */
const useDragScroll = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // 터치 디바이스 여부 확인
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!scrollRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging || !scrollRef.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; // 스크롤 속도 조정
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUpOrLeave = () => {
    setIsDragging(false);
  };

  return {
    scrollRef,
    isDragging,
    // 터치 디바이스에서는 이벤트 핸들러를 등록하지 않음
    handlers: isTouchDevice
      ? {}
      : {
          onMouseDown: handleMouseDown,
          onMouseMove: handleMouseMove,
          onMouseUp: handleMouseUpOrLeave,
          onMouseLeave: handleMouseUpOrLeave,
        },
  };
};

export default useDragScroll;
